import clsx from "clsx";
import { addDays, format } from "date-fns";
import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import FacilitySelect from "components/FacilitySelect";

import useStyles from "./styles";

export interface Props {
  horse: racehorse360.IHorse;
  start: Date;
  end: Date;
  selectedFacility: racehorse360.IFacility;
  onChangeFacility: (facility: racehorse360.IFacility) => void;
}

const ScheduleHeader = React.memo((props: Props) => {
  const { start, end, selectedFacility, onChangeFacility } = props;
  const classes = useStyles();

  const days = new Array(7)
    .fill(start)
    .map((d, i) => format(addDays(d, i), "iii").toUpperCase());

  const handleChangeFacility = (facility: racehorse360.IFacility) => {
    onChangeFacility(facility);
  };

  return (
    <Grid className={classes.root} container>
      <Grid item xs={6} className={classes.dates}>
        <Typography
          variant={"h6"}
          className={clsx(classes.title, classes.normalLine)}
        >
          Workout Schedule
        </Typography>
        <Typography
          variant={"caption"}
          className={clsx(
            classes.datesRange,
            classes.normalLine,
            classes.primary600
          )}
        >
          {format(start, "MMM dd")} - {format(end, "MMM dd")}
        </Typography>
      </Grid>
      <Grid item xs={6} className={classes.schedule}>
        <Typography
          variant={"caption"}
          className={clsx(
            classes.scheduling,
            classes.normalLine,
            classes.primary600
          )}
        >
          Currently Scheduling at
        </Typography>
        <FacilitySelect
          className={classes.facilityName}
          isActive={true}
          selectedFacility={selectedFacility}
          onChange={handleChangeFacility}
        />
      </Grid>
      <Grid item xs={12} className={classes.dayNames}>
        {days.map(d => (
          <Typography key={d} className={classes.day}>
            {d}
          </Typography>
        ))}
      </Grid>
    </Grid>
  );
});

export default React.memo(ScheduleHeader);
